//region :: Imports ::
import {ReactElement} from 'react';
import {ProgressSpinner} from 'primereact/progressspinner';
import MComponent from '../Component';

//endregion

/** */
class MProgressSpinner extends MComponent {

    /** */
    public render(): ReactElement {
        return (<ProgressSpinner strokeWidth="4" animationDuration="1.5s"/>);
    }

}

export default MProgressSpinner;
